import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PartnerLanguage } from 'types';

export interface PartnerLanguagesState {
    data: Record<string, PartnerLanguage>;
}

export const initialState: PartnerLanguagesState = {
    data: {},
};

export const partnerLanguagesSlice = createSlice({
    name: 'partnerLanguages',
    initialState,
    reducers: (create) => ({
        setPartnerLanguages: create.reducer((state, { payload }: PayloadAction<PartnerLanguage[]>) => {
            const result = payload.reduce((acc, data) => {
                acc[data.Id] = data;
                return acc;
            }, {});

            state.data = result;
        }),
        resetPartnerLanguages: create.reducer((state) => {
            state.data = {};
        }),
    }),
    selectors: {
        selectPartnerLanguages: (partnerLanguages) => partnerLanguages.data,
    },
});

export const { setPartnerLanguages, resetPartnerLanguages } = partnerLanguagesSlice.actions;
export const { selectPartnerLanguages } = partnerLanguagesSlice.selectors;
